import { useEffect } from "react";
import { useUIStore } from "../store";

export const useStickyHeader = (
  showSearch: boolean,
  section: string
) => {
  const setIsSticky = useUIStore((s) => s.setIsSticky);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 0);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showSearch, section, setIsSticky]);
};
